import React from 'react';
import { QueryResult, useQuery } from '@apollo/client';
import { MAX_WIDGET_ITEMS } from '../../../constants/widget';
import {
  SortDirection,
  FetchDueQuotesForHomePageInPpcQuery,
  FetchDueQuotesForHomePageInPpcQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-sxp';
import { ProxyGraphClients, abgGraphqlClient } from '@atlassian/temp-client-utils';
import { QuoteV2 } from '@atlassian/cssxp-types-quote';
import { fetchDueQuotesForHomePageInPPC } from './queries/fetch-due-quotes-for-home-page';

type ChildrenProp = (
  args: QueryResult<FetchDueQuotesForHomePageInPpcQuery, FetchDueQuotesForHomePageInPpcQueryVariables>
) => JSX.Element;

const client = abgGraphqlClient(ProxyGraphClients.SXP);

export const DueQuotesQueryWrapper = ({ txaId, children }: { txaId: string; children: ChildrenProp }): JSX.Element => {
  const queryResult = useQuery<FetchDueQuotesForHomePageInPpcQuery, FetchDueQuotesForHomePageInPpcQueryVariables>(
    fetchDueQuotesForHomePageInPPC,
    {
      client,
      variables: {
        searchOptions: {
          first: MAX_WIDGET_ITEMS,
          sort: {
            sortFields: ['expiryDate', 'id'],
            sortFieldsDirections: [SortDirection.ASC, SortDirection.ASC],
          },
        },
        filterOptions: {
          and: [
            { key: 'status', value: QuoteV2.QuoteStatus.OPEN },
            { key: 'transactionAccountId', value: txaId },
            { key: 'sourceSystem', value: 'CCP' },
          ],
        },
      },
      fetchPolicy: 'cache-and-network',
    }
  );

  return children(queryResult);
};
